/**
 * Shopify Filter URL Grouper v6 — Park & Fifth
 *
 * Creates clean, shareable URLs using hash fragments:
 *   /collections/bridesmaid-dresses#color=Powder~Blue~Satin
 *
 * v6 fix: GeoIP redirect strips hash fragments.
 *   - Script saves hash to sessionStorage IMMEDIATELY on load
 *   - After GeoIP redirect, script restores the hash and processes it
 *   - Must be loaded BEFORE the GeoIP app script (place high in <head>)
 */

(function () {

  /* =========================================================
     HASH PRESERVATION — runs FIRST, before anything else
     Must beat the GeoIP redirect.
     ========================================================= */
  var STORAGE_KEY = 'pf_filter_hash';
  var STORAGE_PATH_KEY = 'pf_filter_path';

  // IMMEDIATELY save hash if present
  if (window.location.hash && window.location.hash.length > 1) {
    try {
      // Save the hash and the base path (without locale prefix)
      // so we can match it after redirect to /en-us/ or /en-ca/
      var basePath = window.location.pathname
        .replace(/^\/(en-us|en-ca|fr-ca)\//i, '/');
      sessionStorage.setItem(STORAGE_KEY, window.location.hash);
      sessionStorage.setItem(STORAGE_PATH_KEY, basePath);
    } catch (e) {}
  }

  // Check if we were just redirected and need to restore a hash
  function restoreHash() {
    try {
      var savedHash = sessionStorage.getItem(STORAGE_KEY);
      var savedPath = sessionStorage.getItem(STORAGE_PATH_KEY);
      if (!savedHash) return false;

      // Get current path without locale prefix
      var currentBasePath = window.location.pathname
        .replace(/^\/(en-us|en-ca|fr-ca)\//i, '/');

      // Only restore if we're on the same base page
      if (currentBasePath !== savedPath) {
        // Different page — clear stale data
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PATH_KEY);
        return false;
      }

      // If current URL already has the hash, no need to restore
      if (window.location.hash && window.location.hash.length > 1) {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PATH_KEY);
        return false;
      }

      // If current URL already has native filter params, we're good
      var url = new URL(window.location.href);
      var hasNativeFilters = false;
      url.searchParams.forEach(function (v, k) {
        if (k.startsWith('filter.')) hasNativeFilters = true;
      });
      if (hasNativeFilters) {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PATH_KEY);
        return false;
      }

      // Restore the hash and clear storage
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_PATH_KEY);

      // Apply the saved hash — redirect to native Shopify params
      var hashFilters = parseHashString(savedHash);
      if (!hashFilters) return false;

      var shopifyUrl = buildShopifyUrl(
        window.location.pathname + window.location.search,
        savedHash
      );
      if (!shopifyUrl) return false;

      window.location.replace(shopifyUrl);
      return true;
    } catch (e) {
      return false;
    }
  }

  /* =========================================================
     CONFIG
     ========================================================= */
  var FILTER_MAP = {
    'filter.v.option.color':                   'color',
    'filter.v.m.custom.availability_filter':   'available',
    'filter.p.m.custom.discount':              'discount',
    'filter.p.m.custom.dress_length_custom_2': 'length',
    'filter.p.m.custom.color_custom':          'palette',
    'filter.p.m.custom.fabric_custom_2':       'fabric',
    'filter.v.m.custom.variant_size':          'size',
    'filter.p.m.custom.neckline':              'neckline',
    'filter.p.m.custom.sleeve_length_custom_2':'sleeve',
    'filter.p.m.custom.features':              'features'
  };

  var REVERSE_MAP = {};
  Object.keys(FILTER_MAP).forEach(function (shopifyKey) {
    REVERSE_MAP[FILTER_MAP[shopifyKey]] = shopifyKey;
  });

  /* =========================================================
     HELPERS
     ========================================================= */
  var SEP = '~';

  function encodeValue(str) {
    return str.replace(/ /g, SEP);
  }

  function decodeValue(str) {
    return str.split(SEP).join(' ');
  }

  function parseHashString(hash) {
    hash = hash.replace(/^#/, '');
    if (!hash) return null;

    var pairs = hash.split('&');
    var result = {};
    pairs.forEach(function (pair) {
      var idx = pair.indexOf('=');
      if (idx === -1) return;
      var key = decodeURIComponent(pair.substring(0, idx));
      var rawVal = decodeURIComponent(pair.substring(idx + 1));
      result[key] = rawVal.split(',');
    });

    return Object.keys(result).length > 0 ? result : null;
  }

  function isFilterHash(hash) {
    if (!hash || hash.length < 2) return false;
    var parsed = parseHashString(hash);
    if (!parsed) return false;
    var keys = Object.keys(parsed);
    for (var i = 0; i < keys.length; i++) {
      if (REVERSE_MAP[keys[i]]) return true;
    }
    return false;
  }

  function buildShopifyUrl(basePath, hashString) {
    var hashFilters = parseHashString(hashString);
    if (!hashFilters) return null;

    var url = new URL(basePath, window.location.origin);
    url.hash = '';

    var hasValidFilter = false;
    Object.keys(hashFilters).forEach(function (shortKey) {
      var shopifyKey = REVERSE_MAP[shortKey];
      if (!shopifyKey) return;
      hasValidFilter = true;

      hashFilters[shortKey].forEach(function (encodedVal) {
        url.searchParams.append(shopifyKey, decodeValue(encodedVal));
      });
    });

    return hasValidFilter ? url.toString() : null;
  }

  /* =========================================================
     1. INTERCEPT NAV LINK CLICKS
     ========================================================= */
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('a') : null;
    if (!anchor) {
      var el = e.target;
      while (el && el.tagName !== 'A') el = el.parentElement;
      anchor = el;
    }
    if (!anchor || !anchor.href) return;

    var linkUrl;
    try {
      linkUrl = new URL(anchor.href, window.location.origin);
    } catch (err) {
      return;
    }

    if (linkUrl.origin !== window.location.origin) return;
    if (!isFilterHash(linkUrl.hash)) return;

    var shopifyUrl = buildShopifyUrl(
      linkUrl.pathname + linkUrl.search,
      linkUrl.hash
    );
    if (!shopifyUrl) return;

    e.preventDefault();
    e.stopPropagation();
    window.location.href = shopifyUrl;
  }, true);

  /* =========================================================
     2. DECODE ON PAGE LOAD
     ========================================================= */
  function decodeHashAndRedirect() {
    var hashFilters = parseHashString(window.location.hash);
    if (!hashFilters) return false;

    var url = new URL(window.location.href);
    var hasNativeFilters = false;
    url.searchParams.forEach(function (v, k) {
      if (k.startsWith('filter.')) hasNativeFilters = true;
    });
    if (hasNativeFilters) return false;

    var shopifyUrl = buildShopifyUrl(
      url.pathname + url.search,
      url.hash
    );
    if (!shopifyUrl) return false;

    window.location.replace(shopifyUrl);
    return true;
  }

  /* =========================================================
     3. ENCODE — rewrite URL bar to hash after filtering
     ========================================================= */
  function encodeToHash() {
    var url = new URL(window.location.href);
    var params = url.searchParams;

    var filters = {};
    var hasFilters = false;

    params.forEach(function (value, key) {
      if (!key.startsWith('filter.')) return;
      hasFilters = true;

      var shortKey = FILTER_MAP[key];
      if (!shortKey) {
        shortKey = key
          .replace(/^filter\.v\.option\./, '')
          .replace(/^filter\.v\.m\.custom\./, '')
          .replace(/^filter\.p\.m\.custom\./, '')
          .replace(/^filter\.v\./, '')
          .replace(/^filter\.p\./, '');
      }

      if (!filters[shortKey]) filters[shortKey] = [];
      filters[shortKey].push(encodeValue(value));
    });

    if (!hasFilters) return;

    var hashParts = [];
    Object.keys(filters).forEach(function (shortKey) {
      hashParts.push(
        encodeURIComponent(shortKey) + '=' +
        filters[shortKey].map(encodeURIComponent).join(',')
      );
    });

    var newUrl = new URL(window.location.href);
    var keysToRemove = [];
    newUrl.searchParams.forEach(function (v, k) {
      if (k.startsWith('filter.')) keysToRemove.push(k);
    });
    var uniqueKeys = [];
    keysToRemove.forEach(function (k) {
      if (uniqueKeys.indexOf(k) === -1) uniqueKeys.push(k);
    });
    uniqueKeys.forEach(function (k) { newUrl.searchParams.delete(k); });

    newUrl.hash = hashParts.join('&');

    window.history.replaceState({}, '', newUrl.toString());
  }

  /* =========================================================
     4. BACKWARDS COMPAT — old v2 ?f=eyJ... URLs
     ========================================================= */
  function decodeBase64ParamAndRedirect() {
    var url = new URL(window.location.href);
    var encoded = url.searchParams.get('f');
    if (!encoded) return false;

    try {
      var base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) base64 += '=';
      var json = decodeURIComponent(escape(atob(base64)));
      var filters = JSON.parse(json);

      var newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('f');

      Object.keys(filters).forEach(function (key) {
        filters[key].forEach(function (val) {
          newUrl.searchParams.append(key, val);
        });
      });

      window.location.replace(newUrl.toString());
      return true;
    } catch (e) {
      return false;
    }
  }

  /* =========================================================
     5. INIT
     ========================================================= */

  // First: try to restore hash that was stripped by GeoIP redirect
  if (restoreHash()) return;

  // Handle old v2 ?f= URLs
  if (new URL(window.location.href).searchParams.has('f')) {
    if (decodeBase64ParamAndRedirect()) return;
  }

  // If arriving with a #hash and no native filter params → decode
  if (window.location.hash && window.location.hash.length > 1) {
    if (isFilterHash(window.location.hash)) {
      if (decodeHashAndRedirect()) return;
    }
  }

  // After page loads, encode current filters into hash
  function onReady() {
    encodeToHash();
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady);
  }

  // Catch SPA-style filter changes
  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    setTimeout(encodeToHash, 150);
  };

  var _replaceState = history.replaceState;
  var isOurRewrite = false;

  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    if (!isOurRewrite) {
      setTimeout(function () {
        var current = new URL(window.location.href);
        var hasRawFilters = false;
        current.searchParams.forEach(function (v, k) {
          if (k.startsWith('filter.')) hasRawFilters = true;
        });
        if (hasRawFilters) {
          isOurRewrite = true;
          encodeToHash();
          setTimeout(function () { isOurRewrite = false; }, 200);
        }
      }, 150);
    }
  };

  window.addEventListener('popstate', function () {
    setTimeout(function () {
      if (window.location.hash && window.location.hash.length > 1 && isFilterHash(window.location.hash)) {
        decodeHashAndRedirect();
      }
    }, 100);
  });

})();